module.exports = __webpack_public_path__ + "img/informatikai-es-szerzoi-jog.ab458954.png";